module.exports = __webpack_public_path__ + "static/media/paras_anbhule.c622c25c.png";